module.exports = __webpack_public_path__ + "img/Studios-accueil.579adb5e.jpg";